import Radio from './radio';
import RadioGroup from './radioGroup';
import RadioButton from './radioButton';
Radio.RadioButton = RadioButton;
Radio.RadioGroup = RadioGroup;
export default Radio;
